import React from 'react';
export function Footer() {
  return <footer className="bg-running-dark border-t border-running-muted py-12 px-4 text-center" data-id="element-60">
      <div className="max-w-4xl mx-auto" data-id="element-61">
        <p className="text-gray-400 font-medium mb-2" data-id="element-62">
          Stock Digital™ — stockdigital.shop
        </p>
        <p className="text-gray-500 text-sm" data-id="element-63">
          Porque entrenar corredores no debería costarte todos los domingos del
          año.
        </p>
      </div>
    </footer>;
}